module.exports = __webpack_public_path__ + "static/media/Soybean_Green.6f0c68a9.svg";